<template>
    <div class="nav">
        <div class="dev">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="grid-content bg-purple">盘点人：
                        <el-input v-model="checkUserName" disabled style="width: 150px"></el-input></div>
                </el-col>

                <el-col :span="4">
                    <div class="grid-content bg-purple">盘点日期：
                        <el-input v-model="date" disabled style="width: 150px"></el-input></div>
                </el-col>

                <el-col :span="4" v-show="this.lookid">
                    <div class="grid-content bg-purple">审核人：
                        <el-input v-model="reviewUserName" disabled style="width: 150px"></el-input></div>
                </el-col>
                <el-col :span="4" v-show="this.lookid">
                    <div class="grid-content bg-purple">审核日期：
                        <el-input v-model="reviewDate" disabled style="width: 150px"></el-input></div>
                </el-col>
                <el-col :span="2" style="float: right" v-if="this.lookid!==''">
                    <div class="distanceLeft">
                        <el-button type="primary" class="el-icon-download" v-show="this.lookid" @click.native="download()"></el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <template>
            <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="tableHeaderColor">
                <el-table-column prop="medicineName" label="药品名称" width="200px"></el-table-column>
                <el-table-column prop="manufacturer" label="产地"></el-table-column>
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="number" label="库存数量"></el-table-column>

                <el-table-column prop="actualNumber" label="实际数量">

                </el-table-column>

                <el-table-column prop="diffNumber" label="盘盈盘亏"></el-table-column>
            </el-table>
        </template>


        <div class="block">
            <el-pagination
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size=this.Size
                    layout="total,prev, pager, next, jumper"
                    :total=this.total>
            </el-pagination>
        </div>
        <el-row style="margin: 30px 0px">
            <el-button type="primary" @click="audit" v-show="this.id">审核</el-button>
            <router-link to="./checkStock">
                <el-button type="info" plain>返回</el-button>
            </router-link>
        </el-row>
    </div>
</template>
<script>

  export default {
    name: 'nowStock',
    data() {
      return {
          total: 0,
          Current: 1,
          Size: 10,
          currentPage: 0,  //当前页数
            checkUserName: '',
            reviewDate: '',
            reviewUserName: '',
            row: [],
            date: '',
            tableData: [],
            id: '',
            lookid: '',
          downloadList:[],
      }
    },

    mounted: function () {
      this.id = this.$route.query.id;
      this.lookid = this.$route.query.look;
      this.axios();
    },
    methods: {
        download(){
            if (this.lookid != '' && this.lookid != undefined) {
                this.$axios({
                    url: '/api/medicine/check/' +this.Current+'/'+10000+'/'+this.lookid,
                    method: 'GET',
                }).then(res => {
                    this.downloadList = res.data.data.checkDetailsResponsePage.content;
                    this.downloadList.forEach(item=>{
                        item.number = item.actualNumber - item.diffNumber;
                    })
                    require.ensure([], () => {
                        const { export_json_to_excel } = require('../../vendor/Export2Excel.js');　　//引入文件　　　　　　
                        const tHeader = ['药品名称', '产地', '单位','库存数量','实际数量','盘盈盘亏']; //将对应的属性名转换成中文
                        // const tHeader = [];

                        const filterVal = ['medicineName', 'manufacturer', 'unit','number','actualNumber','diffNumber'];//table表格中对应的属性名　　　　　 　　　
                        const list = this.downloadList;
                        const data = this.formatJson(filterVal, list);

                        var filename = '库存盘点' + new Date().toLocaleDateString();
                        export_json_to_excel(tHeader, data, filename);
                    })
                }).catch(err => {
                    console.log(err.data);
                })
            }
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.Size = val;
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.Current = val;
            this.axios();
        },
        //审核接口
      axios: function () {
        if (this.id != '' && this.id != undefined) {
          this.$axios({
            url: '/api/medicine/check/' +this.Current+'/'+this.Size+'/'+this.id,
            method: 'GET',
          }).then(res => {
            this.checkUserName = res.data.data.checkUserName;
            this.date = res.data.data.date;
              this.total = res.data.data.checkDetailsResponsePage.totalElements;
              this.tableData = res.data.data.checkDetailsResponsePage.content;
          }).catch(err => {
            console.log(err.data);
          })
        }

        //查看详情接口
        if (this.lookid != '' && this.lookid != undefined) {
          this.$axios({
            url: '/api/medicine/check/' +this.Current+'/'+this.Size+'/'+this.lookid,
            method: 'GET',
          }).then(res => {
            this.checkUserName = res.data.data.checkUserName;
            this.total = res.data.data.checkDetailsResponsePage.totalElements;
            this.date = res.data.data.date;
            this.reviewUserName = res.data.data.reviewUserName;
            this.reviewDate = res.data.data.reviewDate;
            this.tableData = res.data.data.checkDetailsResponsePage.content;
            this.tableData.forEach(item=>{
                item.number = item.actualNumber - item.diffNumber;
            })
          }).catch(err => {
            console.log(err.data);
          })
        }
      },
      audit: function () {
        this.$axios({
          url: '/api/medicine/check/review/' + this.id,
          method: 'PUT'
        }).then(res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '审核成功'
            })
            this.$router.push({path: './checkStock'})
          } else {
            this.$alert(res.data.msg)
          }
        }).catch(err => {
          console.log(err.data);
        })
      },
      tableHeaderColor({row, column, rowIndex, columnIndex}) {
        if (rowIndex === 0) {
          return "background-color:#f2f2f2;color: #a4a7af;";        }
      },
    }
  }
</script>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .nav {
        height: auto;
        width: 98%;
        margin-left: 18px;
        background-color: white;
        /*margin-top: 20px;*/
        /*margin-left: 10px;*/
        padding-bottom: 50px;
    }
    .block {
        margin-top: 20px;
        padding-left: 33%;
    }
    .dev {
        width: 100%;
        /*border-bottom: 1px solid #e7e7e7;*/
        color: #95b2d4;
        line-height: 65px;
        font-family: 微软雅黑;
        /*background-color: #e8d9dc2e;*/
        padding-left: 5px;
    }
    .distanceLeft {
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// inventoryAudit.vue?37d782e5